import { stdObject } from "../../../data/types/stdObject";

export const writePayLabel = (id: string | number, paymentList: stdObject) => {
  const index = paymentList.findIndex((e: stdObject) => e.CODTPA === id);
  return index === -1 ? id : paymentList[index].NOMTPA;
};
